import { DI_CONTAINER_TYPE, initStore as initStoreBase } from '@edikk-edikk/ui';
import { reducerBase } from '@edikk-edikk/redux/slice-base';
import { reducerNotifier } from '@edikk-edikk/notifier';
import { Container } from 'inversify';
import { NetworkServiceInterface } from '@edikk-edikk/network-service';
import { determineApiUrl } from '@edikk-edikk/shared';
import { Api } from '#src/react/api/Api';
import { reducerMenu } from '#baseMenu/reducers/slice-menu';
import { reducerCitiesInModal } from '#baseCitiesInModal/reducers';

const initStore = (
  diContainer: Container,
  domain: string,
  pathname: string,
  preloadedState = {},
) => {
  const api = diContainer.get<Api>(DI_CONTAINER_TYPE.api);
  const networkService = diContainer.get<NetworkServiceInterface>(DI_CONTAINER_TYPE.networkService);

  const url = new URL(determineApiUrl());
  if (url.toString() !== process.env.SERVER_API_URL) {
    url.host = domain;

    networkService.setBaseUrl(url.toString());
  }

  return initStoreBase({
    diContainer,
    domain,
    pathname,
    preloadedState,
    reducer: {
      base: reducerBase,
      notifier: reducerNotifier,
      menu: reducerMenu,
      citiesInModal: reducerCitiesInModal,
      [api.getApiBase().reducerPath]: api.getApiBase().reducer,
      [api.getApiReviewList().reducerPath]: api.getApiReviewList().reducer,
      [api.getApiAdvertListByDate().reducerPath]: api.getApiAdvertListByDate().reducer,
      [api.getApiAdvertListByService().reducerPath]: api.getApiAdvertListByService().reducer,
      [api.getApiPage().reducerPath]: api.getApiPage().reducer,
      [api.getApiCitiesInModal().reducerPath]: api.getApiCitiesInModal().reducer,
    },
    middleware: [
      api.getApiBase().middleware,
      api.getApiReviewList().middleware,
      api.getApiAdvertListByDate().middleware,
      api.getApiAdvertListByService().middleware,
      api.getApiPage().middleware,
      api.getApiCitiesInModal().middleware,
    ],
  });
};

export { initStore };
